import React from 'react';
import { useSettings } from '../../context/SettingsContext';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { settings } = useSettings();
  const business = settings?.business || {
    name: 'London Builders',
    address: 'Sakina, Raska Zone, Arusha, Tanzania',
    phone: '+255656472123',
    email: 'londonbuilderstz@gmail.com',
    workingHours: {
      weekdays: 'Mon-Fri: 8:30am - 5:30pm',
      saturday: 'Sat: 9:00am - 3:00pm',
      sunday: 'Closed'
    }
  };

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__top">
          <div className="footer__brand">
            <a href="#home" className="footer__logo">
              <img 
                src="/images/logo.png" 
                alt="London Builders" 
                className="footer__logo-img"
              />
            </a>
            <p className="footer__description">
              Your Vision, Our Expertise. We deliver excellence, innovation, and unwavering 
              commitment to quality. Your trusted construction partner in Tanzania.
            </p>
            <div className="footer__social">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="Facebook">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
                </svg>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="Twitter">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"/>
                </svg>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="Instagram">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="2" width="20" height="20" rx="5"/>
                  <circle cx="12" cy="12" r="4"/>
                  <circle cx="18" cy="6" r="1" fill="currentColor" stroke="none"/>
                </svg>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="LinkedIn">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2zM4 6a2 2 0 100-4 2 2 0 000 4z"/>
                </svg>
              </a>
            </div>
          </div>
          
          <div className="footer__links">
            <div className="footer__column">
              <h4 className="footer__column-title">Services</h4>
              <ul className="footer__list">
                <li><a href="#services">Residential Construction</a></li>
                <li><a href="#services">Commercial Projects</a></li>
                <li><a href="#services">Renovations & Extensions</a></li>
                <li><a href="#services">Interior Fit-Outs</a></li>
                <li><a href="#services">Project Management</a></li>
              </ul>
            </div>
            
            <div className="footer__column">
              <h4 className="footer__column-title">Company</h4>
              <ul className="footer__list">
                <li><a href="#about">About Us</a></li>
                <li><a href="#projects">Our Projects</a></li>
                <li><a href="#about">Our Team</a></li>
                <li><a href="#contact">Testimonials</a></li>
                <li><a href="#contact">Careers</a></li>
              </ul>
            </div>
            
            <div className="footer__column">
              <h4 className="footer__column-title">Contact</h4>
              <ul className="footer__list footer__list--contact">
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
                    <circle cx="12" cy="10" r="3"/>
                  </svg>
                  {business.address}
                </li>
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/>
                  </svg>
                  <a href={`tel:${business.phone}`}>{business.phone}</a>
                </li>
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                  <a href={`mailto:${business.email}`}>{business.email}</a>
                </li>
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12,6 12,12 16,14"/>
                  </svg>
                  <span>
                    {business.workingHours?.weekdays}<br/>
                    {business.workingHours?.saturday}
                    {business.workingHours?.sunday ? <><br/>{business.workingHours?.sunday}</> : null}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer__bottom">
          <p className="footer__copyright">
            © {currentYear} {business.name || 'London Builders'}. All rights reserved.
          </p>
          <div className="footer__legal">
            <a href="#home">Privacy Policy</a>
            <a href="#home">Terms of Service</a>
            <a href="#home">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

